import { store } from '../../app/store'
import { inventoriesApiSlice } from '../inventories/inventoriesApiSlice'
import { usersApiSlice } from '../users/usersApiSlice';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

const Prefetch = () => {
    const { isAdmin } = useAuth()
    // useEffect(() => {
    //     store.dispatch(renergiesApiSlice.util.prefetch('getRenergies', 'renergiesList', { force: true }))
    //     store.dispatch(usersApiSlice.util.prefetch('getUsers', 'usersList', { force: true }))
    // }, [])

    useEffect(() => {
        // console.log('subscribing')
        // const renergies = store.dispatch(renergiesApiSlice.endpoints.getRenergies.initiate())
        const inventories = store.dispatch(inventoriesApiSlice.endpoints.getInventories.initiate())
        const users = isAdmin
            ? store.dispatch(usersApiSlice.endpoints.getUsers.initiate())
            : null

        return () => {
            // console.log('unsubscribing')
            // renergies.unsubscribe()
            inventories.unsubscribe()
            users?.unsubscribe?.()
        }
    }, [isAdmin])
    return <Outlet />
}
export default Prefetch